import type { FC } from 'react';
import ReactPaginate from 'react-paginate';

import {
  IconArrowLeft,
  IconArrowRight,
  type QueryState,
  Row,
  Select,
  Typography,
  updateQueryStateTable,
} from 'enable-ui';

import { COLOR_CONFIG } from 'constants/color';

import { getDisplayRowPagination } from './helper';
import { StyledPaginationButton, StyledPaginationContainer } from './style';

export const Pagination: FC<{
  total: number;
  pageClassName?: string;
  breakLabel?: React.ReactNode;
  activeClassName?: string;
  queryState: QueryState;
  tableKey: string;
  showRowsPerPage?: boolean;
  rowsPerPageOptions?: number[];
  showTotal?: boolean;
  rowsPerPage?: boolean;
  forcePage?: boolean;
}> = ({
  total,
  pageClassName,
  breakLabel,
  activeClassName,
  queryState,
  tableKey,
  showRowsPerPage = true,
  rowsPerPageOptions = [12, 20],
  showTotal = true,
  rowsPerPage = 12,
  forcePage = 1,
}) => {
  const handlePageClick = (event: { selected: number }) => {
    const newPage = event.selected + 1;

    if (!newPage) {
      return;
    }

    updateQueryStateTable(tableKey, {
      ...queryState,
      page: newPage,
    });
  };

  const totalPage = queryState?.limit ? Number(total) / Number(queryState.limit) : 0;

  const updatePage = ({ selected: page }: { selected: number }) => {
    updateQueryStateTable(tableKey, {
      page,
    });
  };

  const handleRowsPerPageChange = (item: any) => {
    updateQueryStateTable(tableKey, {
      limit: Number(item.key),
    });
    updatePage?.({ selected: 1 });
  };

  return (
    <StyledPaginationContainer className="pagination-container">
      <ReactPaginate
        previousLabel={<StyledPaginationButton>{IconArrowLeft}</StyledPaginationButton>}
        nextLabel={<StyledPaginationButton> {IconArrowRight}</StyledPaginationButton>}
        onPageChange={handlePageClick}
        pageCount={Math.ceil(totalPage)}
        forcePage={queryState?.page - 1}
        pageClassName={pageClassName || 'page-item'}
        breakLabel={breakLabel || '...'}
        activeClassName={activeClassName || 'active'}
      />
      {showRowsPerPage && (
        <Row className="es-paginate-info" align="center" style={{ width: 'fit-content', gap: 16 }}>
          {showTotal && (
            <Typography
              weight={400}
              style={{
                whiteSpace: 'nowrap',
                fontSize: '18px',
                lineHeight: '26px',
                color: COLOR_CONFIG['neutral-text'],
              }}
            >{`${getDisplayRowPagination(Number(queryState.page), Number(queryState.limit), total)} of ${total}`}</Typography>
          )}
          <Select
            width={100}
            size="small"
            options={rowsPerPageOptions.map((el) => ({
              key: String(el),
              label: `${el}/page`,
            }))}
            onChange={handleRowsPerPageChange}
            selectedKeys={[String(queryState.limit || rowsPerPageOptions[0])]}
          />
        </Row>
      )}
    </StyledPaginationContainer>
  );
};
